import { Globe2, Target, Layers, Gauge } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WHY_CHOOSE, IMAGES } from "@/data/site";

const ICONS = [Globe2, Target, Layers, Gauge];

const WhyChoose = () => {
  return (
    <section id="why" data-testid="why-section" className="relative bg-navy-900 py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 eb-grain opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left intro + image */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="eb-overline text-brand-blue">Why Echo Bravo</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-[2.7rem] leading-[1.08] tracking-tight font-black text-white">
                Command experience. Commercial insight. Trusted results.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base leading-relaxed text-silver-300/80 font-medium">
                We combine seagoing leadership with modern maritime consultancy to
                help Owners, Operators, Charterers and Investors make better decisions.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-10">
              <img
                src={IMAGES.whyAccent}
                alt="Ship's helm and navigation compass"
                className="w-full h-64 object-cover grayscale-[20%]"
                loading="lazy"
              />
            </Reveal>
          </div>

          {/* Right: technical grid */}
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 border-t border-l border-white/10">
              {WHY_CHOOSE.map((item, i) => {
                const Icon = ICONS[i];
                return (
                  <Reveal
                    key={item.title}
                    delay={i * 0.08}
                    className="border-b border-r border-white/10"
                  >
                    <div
                      data-testid={`why-card-${i}`}
                      className="group h-full p-8 transition-colors duration-300 hover:bg-white/[0.03]"
                    >
                      <div className="flex items-center gap-4">
                        <Icon size={24} className="text-brand-blue" />
                        <span className="text-xs font-black text-white/20 tracking-tight">
                          0{i + 1}
                        </span>
                      </div>
                      <h3 className="mt-6 text-xl font-bold text-white tracking-tight">
                        {item.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-silver-300/70">
                        {item.text}
                      </p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
